import { hasLocizeTranslation } from 'lib/utils/locize'

const checkIsSingleSize = (sizesArray = []) => sizesArray?.length === 1

const getMatchedSizeObject = (sizesArray) => ({
  '%t': sizesArray.pop(),
  '%s': sizesArray.join(', '),
})

export const getUpdatedSizeInfoText = (t, updatedSizes) => {
  const updatedSizeInfo = hasLocizeTranslation(
    t,
    'PRODUCT_SIZE_UPDATE_GUIDE_DIALOGS_INFO',
    'Check our new measurements for size %s & %t before ordering!',
  )
  const isSingleSize = checkIsSingleSize(updatedSizes)
  const updatedSizesObj = getMatchedSizeObject([...updatedSizes])

  return isSingleSize
    ? updatedSizeInfo.replace('%s & %t', updatedSizes?.[0])
    : updatedSizeInfo.replace(/%s|%t/gi, (matched) => updatedSizesObj[matched])
}

export const getAddedSizeInfoText = (t, addedSizes) => {
  const addedSizeInfo = hasLocizeTranslation(
    t,
    'PRODUCT_SIZE_ADD_GUIDE_DIALOGS_INFO',
    'We have added size %s & %t.$nCheck the sizing chart before placing an order!',
  ).replace('$n', `\n`)
  const isSingleSize = checkIsSingleSize(addedSizes)
  const addedSizesObj = getMatchedSizeObject([...addedSizes])

  return isSingleSize
    ? addedSizeInfo.replace('%s & %t', addedSizes?.[0])
    : addedSizeInfo.replace(/%s|%t/gi, (matched) => addedSizesObj[matched])
}

export const getUpdatedAndAddedSizeInfoText = (t, updatedSizes, addedSizes) => {
  const updatedSizeInfo = hasLocizeTranslation(
    t,
    'PRODUCT_SIZE_UPDATE_INFO',
    'Measurements for size %s & %t changed.',
  )
  const addedSizeInfo = hasLocizeTranslation(
    t,
    'PRODUCT_SIZE_ADD_INFO',
    `We've added size %s & %t`,
  )
  const isSingleAddedSize = checkIsSingleSize(addedSizes)
  const isSingleUpdatedSize = checkIsSingleSize(updatedSizes)

  const addedSizesObject = getMatchedSizeObject([...addedSizes])
  const updatedSizesObject = getMatchedSizeObject([...updatedSizes])

  const updatedInfo = isSingleUpdatedSize
    ? updatedSizeInfo.replace('%s & %t', updatedSizes?.[0])
    : updatedSizeInfo.replace(
        /%s|%t/gi,
        (matched) => updatedSizesObject[matched],
      )
  const addedInfo = isSingleAddedSize
    ? addedSizeInfo.replace('%s & %t', addedSizes?.[0])
    : addedSizeInfo.replace(/%s|%t/gi, (matched) => addedSizesObject[matched])

  return {
    updatedInfo,
    addedInfo,
    miscellaneousText: hasLocizeTranslation(
      t,
      'PRODUCT_SIZE_UPDATE_AND_ADD_INFO',
      `Check the sizing chart before placing an order!`,
    ),
  }
}
